import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS, FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { EquipmentItem } from 'components/BusinessToolForm/Sections/BusinessOperations/Equipment/EquipmentItem';
import { equipmentSectionInitialValues } from 'components/BusinessToolForm/Sections/BusinessOperations/Equipment/utils/form';
import { ASSETS_NAMES, prefix } from 'components/BusinessToolForm/Sections/BusinessOperations/OtherAssets/utils/form';

import { concatWithDot } from 'helpers/string';

export const OtherAssets: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
    FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.ASSETS,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('businessOperations.assets.title')}
          section={FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      {/* 6.3.1 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.assets.description')}
        aiFieldName={concatWithDot(prefix, ASSETS_NAMES.DESCRIPTION)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, ASSETS_NAMES.DESCRIPTION)}
          name={concatWithDot(prefix, ASSETS_NAMES.DESCRIPTION)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 6.3.2 */}
      <FormSectionCard disabled={!canAccess} title={t('businessOperations.assets.group.title')} collapsible>
        <FieldArrayComponent
          name={concatWithDot(prefix, ASSETS_NAMES.GROUPS)}
          initialItem={equipmentSectionInitialValues}
          buttonText={t('businessOperations.assets.group.buttonText')}
          disabled={!canAccess}
        >
          {(namePrefix) => <EquipmentItem isCurrentEquipment name={namePrefix} disabled={!canAccess} />}
        </FieldArrayComponent>
      </FormSectionCard>
      {/* 6.3.3 */}
      <FormSectionCard disabled={!canAccess} title={t('businessOperations.assets.purchasedGroup.title')} collapsible>
        <FieldArrayComponent
          name={concatWithDot(prefix, ASSETS_NAMES.PURCHASED_GROUPS)}
          initialItem={equipmentSectionInitialValues}
          buttonText={t('businessOperations.assets.purchasedGroup.buttonText')}
          disabled={!canAccess}
        >
          {(namePrefix) => <EquipmentItem name={namePrefix} disabled={!canAccess} />}
        </FieldArrayComponent>
      </FormSectionCard>
    </>
  );
};
